import { NgModule } from '@angular/core'
import { CollectionHeaderComponent } from './collection-header.component'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { AnalyticsModule } from '../../../../shared/analytics/analytics.module'
import { AdsModule } from '../../../../shared/ads/ads.module'
import { SharedModule } from '../../../../shared/shared.module'
import { ResponsiveImageModule } from '../../../../shared/responsive-image/responsive-image.module'
import { CollectionCtaComponentModule } from '../collection-cta/collection-cta.component.module'
import { CollectionCtaComponent } from '../collection-cta/collection-cta.component'
import { OldTabsModule } from 'src/app/libs/_deprecated/tabs/old-tabs.module'
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AnalyticsModule,
    OldTabsModule,
    AdsModule,
    SharedModule,
    ResponsiveImageModule,
    CollectionCtaComponentModule
  ],
  declarations: [CollectionHeaderComponent],
  exports: [CollectionHeaderComponent, CollectionCtaComponent]
})
export class CollectionHeaderComponentModule {}
